import React, { FunctionComponent } from 'react';
import {UserRole, ErrorType} from 'enums';
import {UserService} from 'services';
import {ErrorMessage} from 'components/ErrorMessage/ErrorMessage';

interface IRequireRoleProps {
    role: UserRole;
}

export const RequireRole: FunctionComponent<IRequireRoleProps> = (props) => (<>
    {UserService.oktaUserInfo.role >= props.role && props.children}
    {!(UserService.oktaUserInfo.role >= props.role) && (
        <ErrorMessage type={ErrorType.Generic} message={`You do not have sufficient permissions to access this page.`} />
    )}
</>);